// src/menus/ChineseMenu.js
import React from 'react';
import CollapsibleSection from '../components/CollapsibleSection';
import '../styles/MultiSelect.css';

// Shared topics list (if needed for Vocabulary mode)
const topicsList = [
    "Relationships",
    "School and Education",
    "Career",
    "Shopping & Money",
    "Health and Wellness",
    "Food & Dining",
    "Travel & Adventure",
    "Weather & Nature",
    "Science",
    "Technology",
    "History",
    "Philosophy & Deep Thoughts",
    "Spirituality and Religion",
    "Movies & TV",
    "Music",
    "Hobbies & Interests",
    "Colors, Numbers, & Shapes",
    "Fun Facts!"
]; // Semicolon added

// Grammar items per Level for Chinese (Placeholders for you to fill)
export const chineseGrammarItems = { // Renamed variable
    "HSK1": [
        "Actions in Progress with 在 (zai): Use 在 before a verb to indicate an ongoing action, as in 我们正在吃饭。",
        "Negation with 没有 (mei): Use 没有 to negate possession or existence, e.g., 我没有钱。",
        "Standard Negation with 不 (bu): Attach 不 before a verb or adjective to indicate negation, e.g., 他们不是坏孩子。",
        "Inclusive 'all' with 都 (dou): Place 都 before a verb or adjective to imply all subjects, e.g., 我们都住在上海。",
        "Addition with 也 (ye): Insert 也 before a verb or adjective to mean 'also', e.g., 今天也很冷。",
        "Degree Inquiry with 多 (duo): Use 多 after the subject before an adjective to ask about degree, e.g., 他多高？",
        "Mild Negation with 不太 (bu tai): Place 不太 before adjectives to express 'not very', e.g., 他不太高兴。",
        "Conjunction with 和 (he): Use 和 to connect two nouns meaning 'and', e.g., 我和他都不去。",
        "Post-Time Expression with 以后 (yihou): Attach 以后 after a time expression to denote 'after', e.g., 10点以后，我不在家。",
        "Pre-Time Expression with 以前 (yiqian): Place 以前 after a time expression to denote 'before', e.g., 十点以前，我在家。",
        "Time Word Order: Position time expressions flexibly before or after the subject, e.g., 我明天有空 or 明天我有空。",
        "Age Expression with 岁 (sui): Follow a numeral with 岁 to state age, e.g., 我20岁。",
        "Measure Word with 个 (ge): Use 个 between a number and a noun, e.g., 一个人。",
        "Date Structure: Combine 年, 月, and 日 with numbers to form dates, e.g., 今天是2011年11月11日。",
        "Day of Week Structure with 星期 (xingqi): Use 星期 followed by a number or name to indicate the day, e.g., 今天星期三。",
        "Number Structure: Form numbers by combining digits with units, e.g., 三百五十九。",
        "Advanced Time Structure with 点/钟 and 分 (dian/feng): Combine 点(钟) and 分 for precise time, e.g., 现在十一点十八分。",
        "Basic Time Structure with 点 (dian): Use 点 after a numeral to indicate the hour, e.g., 现在十一点。",
        "Close Possession without 的: Directly place a pronoun before a noun for close possession, e.g., 我女朋友。",
        "Completion with 了 (le): Insert 了 after the verb to mark a completed action, e.g., 我吃了两个苹果。",
        "Cessation with 了 (le): Use 了 after a negated verb phrase to indicate 'not anymore', e.g., 我不想吃了。",
        "New Situation with 了 (le): End a statement with 了 to denote a new circumstance, e.g., 吃饭了！",
        "Possessive with 的 (de): Insert 的 between nouns to express possession, e.g., 我的老师。",
        "Question Particle with 呢 (ne): Append 呢 at the end of a sentence to seek a follow-up, e.g., 我很好。你呢？",
        "Interjection with 啊 (a): Add 啊 at the end of a sentence for affirmation or mild surprise, e.g., 是啊！谁啊？",
        "Softening with 吧 (ba): Append 吧 to soften a statement or suggestion, e.g., 这样不太好吧。",
        "Suggestion with 吧 (ba): Use 吧 following a command to propose a suggestion, e.g., 我们走吧。",
        "Directional Verbs with 来/去 (lai/qu): Prepend 来 or 去 before a place to indicate movement, e.g., 我来上海一年了。",
        "Existence in a Location with 在 (zai): Use 在 before a location to show presence, e.g., 老师在上海。",
        "Existence with 有 (you) – location: Place 有 after a place to state that something exists, e.g., 我们学校有很多学生。",
        "Possession with 有 (you): Use 有 after the subject to denote possession, e.g., 我有钱。",
        "Polite Request with 请 (qing): Begin with 请 before a verb to make a polite request, e.g., 请坐。",
        "Naming with 叫 (jiao): Use 叫 to inquire or state a name, e.g., 你叫什么名字？",
        "Movement with 去 (qu): Prepend 去 before a place to indicate going there, e.g., 我去学校。",
        "Ability with 能 (neng): Place 能 before a verb to express capability, e.g., 你能学好吗？",
        "Learned Skill with 会 (hui): Use 会 before a verb to indicate a learned ability, e.g., 他会说中文。",
        "Future Action with 会 (hui): Use 会 to express a future event, e.g., 明天你会来吗？",
        "Desire with 想 (xiang): Prepend 想 before a verb to express a wish, e.g., 我想去。",
        "Method Inquiry with 怎么 (zenme): Begin with 怎么 before a verb to ask how to perform an action, e.g., 怎么走？",
        "Location in Verb Phrases with 在 (zai): Insert 在 before the verb to specify where an action occurs, e.g., 我在上海工作。",
        "Past Negation with 没有 (meiyou): Use 没有 before a verb to negate a past action, e.g., 我没有去酒吧。",
        "Basic Sentence Order: Follow a subject-verb-object structure, e.g., 我爱你。",
        "Linking with 是 (shi): Use 是 between two nouns to equate or identify, e.g., 我是学生。",
        "Excessive Degree with 太 (tai): Use 太 before an adjective and 了 after to indicate excess, e.g., 太好了！",
        "Simple Noun-Adjective Structure with 很 (hen): Combine a noun with 很 and an adjective for basic descriptions, e.g., 我很好。",
        "Quantity with 一些 (yixie): Place 一些 before a noun to indicate an unspecified amount, e.g., 这里有一些咖啡。",
        "Money Counting: Combine numbers with units like 块, 毛, and 钱 to denote money, e.g., 给你五块三毛。",
        "Measure Word Questions with 几 (ji): Use 几 before a measure word and noun to ask about quantity, e.g., 几个人？",
        "Opinion Inquiry with 怎么样 (zenmeyang): Append 怎么样 to ask for opinions or conditions, e.g., 你最近怎么样？",
        "Use of Question Words: Employ interrogatives such as 什么, 什么时候, 谁, 哪儿 to form questions, e.g., 你是谁？",
        "Completed Action Query with 了吗 (le ma): Insert 了 before 吗 to ask about completed actions, e.g., 你吃饭了吗？",
        "Yes-No Questions with 吗 (ma): Append 吗 to a statement to form a yes/no question, e.g., 他是老板吗？",
        "Emphasis with 是...的 (shi... de): Use 是...的 to emphasize details of an action or event, e.g., 你是怎么来的吗？"

    ],
    "HSK2": [
        "Continuation with 还 (hai): Use 还 after the subject with a verb phrase or adjective to indicate that an action or state is continuing, e.g., 你还在看书？",
        "Emphasis with 就是 (jiushi): Place 就是 before a verb to emphasize certainty or to stress a point, e.g., 我父母就是不让我一个人去。",
        "Emphasizing Quantity with 都 (dou): Use 都 after subjects like 大家 or 很多人 to indicate that the statement applies to all, e.g., 很多地方都有wifi。",
        "Expressing 'About to' with 还有…就要…了 (jiuyao): Combine 还有 + time period + 就要 + verb phrase + 了 to denote an impending event, e.g., 还有五天就要放假了。",
        "Expressing 'Again' in the Future with 再 (zai): Prepend 再 to a verb to indicate that an action will be repeated in the future, e.g., 我下次再来。",
        "Expressing 'Already' with 都…了 (dou): Use 都 followed by a time expression and 了 to indicate that an action has already occurred, e.g., 都九点了，快点起床！",
        "Expressing 'Already' with 已经…了 (yijing): Place 已经 before the verb phrase and 了 at the end to show that something has already happened, e.g., 他已经走了。",
        "Expressing 'And Also' with 还 (hai): Use 还 before a verb to add another related element, e.g., 她有一个弟弟，还有一个妹妹。",
        "Expressing Earliness with 就 (jiu): Insert 就 between the time expression and the verb to indicate that an action happens earlier than expected, e.g., 我昨晚八点半就睡觉了。",
        "Expressing 'Then' with 就 (jiu): Prepend 就 to a verb phrase to denote immediacy or that something follows promptly, e.g., 我们现在有时间，就去吧。",
        "Negative Commands with 别 (bie): Use 别 before a verb to issue a command to refrain from an action, e.g., 别走。",
        "Asking About Degree with 多 (duo): Use 多 after the subject with an adjective to inquire about its degree, e.g., 他多高？",
        "Expressing 'A Little Too' with 有点儿 (you dian): Prepend 有点儿 to an adjective to indicate a slight excess, e.g., 我有点饿。",
        "Expressing Distance with 离 (li): Use 离 between two places along with an adverb like 很 to describe proximity, e.g., 我家离大学很近。",
        "Expressing 'Even More' with 更 (geng): Place 更 before an adjective to express a higher degree or comparison, e.g., 我想找一个更有钱的男朋友。",
        "Expressing 'Really' with 真 (zhen): Use 真 before an adjective to intensify or emphasize, e.g., 你女朋友真漂亮。",
        "Moderating Positive Adjectives with 还 (hai): Use 还 before an adjective to convey a moderate or acceptable quality, e.g., 还可以，还好。",
        "Modifying Nouns with 的 (de): Insert 的 after a modifying phrase to link it to a noun, e.g., 去北京的火车, 今天来的人。",
        "Superlative with 最 (zui): Prepend 最 before an adjective (and optionally add 了) to denote the highest degree, e.g., 谁最有钱？",
        "The Filler Word 那个 (neige): Use 那个 as a hesitation marker or filler in speech, e.g., 那个……你可以做我的女朋友吗？",
        "Reduplication of Measure Words: Repeat a measure word for emphasis, e.g., 个个都很好。",
        "Expressing 'When' with 的时候 (de shihou): Append 的时候 after a noun or phrase to indicate 'when', e.g., 你不在的时候，我会想你。",
        "Indicating an Approximate Number with 多 (duo): Attach 多 after a numeral to indicate an approximate or excess amount, e.g., 三十多岁。",
        "Using 几 (ji) to Mean 'Several': Place 几 before a measure word and noun to ask 'how many', e.g., 桌子上有几本书。",
        "Aspect Particle 着 (zhe): Append 着 after a verb to indicate a continuous or ongoing state, e.g., 我读， 你听着。",
        "Conceding with 吧 (ba): Use 吧 at the end of a sentence to soften a statement or express concession, e.g., 那好吧。",
        "Expressing 'Already' with 了 (le): Append 了 after a verb phrase to signal that an action has been completed, e.g., 你应该问老师，我问了。",
        "Expressing Experience with 过 (guo): Attach 过 after a verb to indicate that the action has been experienced in the past, e.g., 我去过中国。",
        "Modal Particle 呢 (ne): Append 呢 at the end of a sentence to add emphasis or soften the tone, e.g., 我不要回家，还早呢！",
        "Using 过 with 了 (guo + le): Combine 过 and 了 after a verb to denote a completed past experience, e.g., 她吃过了。",
        "Basic Comparisons with 比 (bi): Use 比 between two nouns followed by an adjective to make comparisons, e.g., 你比我胖。",
        "Expressing 'For' with 给 (gei): Use 给 after the subject with a recipient and verb phrase to indicate doing something for someone, e.g., 妈妈在给孩子们做饭。",
        "Expressing 'From...to...' with 从…到… (cong...dao): Use 从 followed by 到 to indicate a range or span, e.g., 从1号到5号我在上海。",
        "Expressing 'Toward' with 往 (wang): Prepend 往 before a direction or place to denote movement toward it, e.g., 往东走。",
        "Using 对 with Verbs (dui): Place 对 before a person along with a verb to indicate that the action is directed at someone, e.g., 宝宝对我笑了。",
        "Using 姓 (xing): Use 姓 before a surname to ask for or state a person's family name, e.g., 你姓什么？",
        "Auxiliary Verb 要 (yao): Use 要 before a noun or verb to express need or intention, e.g., 我要一杯水。",
        "Expressing 'Be Going To' with 要 (yao): Follow 要 with a verb (and optionally 了) to indicate future plans, e.g., 我要去吃饭，你去吗？",
        "Expressing Permission with 可以 (keyi): Prepend 可以 before a verb to ask for or grant permission, e.g., 这里可以吸烟吗？",
        "Expressing Desire with 要 (yao): Use 要 before a verb to indicate a desire or wish, e.g., 我要吃饭。",
        "Actions in a Row: Combine sequential verb phrases to denote consecutive actions, e.g., 我们去咖啡店喝咖啡吧。",
        "Expressing 'Together' with 一起 (yiqi): Prepend 一起 before a verb to indicate that an action is done collectively, e.g., 我们一起去吧！",
        "Measure Words for Verbs: Use a number plus a measure word after a verb to indicate the frequency or repetition of an action, e.g., 做三次, 读两遍。",
        "Negative Commands with 不要 (buyao): Prepend 不要 before a verb to instruct someone not to perform an action, e.g., 不要说英文！",
        "Reduplication of Verbs: Repeat a verb to create a casual or softened command, e.g., 你看看。",
        "Special Cases of 在 after Verbs: Insert 在 after a verb to indicate the location of an action, e.g., 我住在北京, 放在这里。",
        "Using 到 (dao) to Mean 'To Go To': Prepend 到 before a place to express arriving at or going to a destination, e.g., 我到上海。",
        "Using 好 (hao) to Mean 'Easy': Use 好 before a verb to indicate that the action is easy to perform, e.g., 好做, 好买。",
        "Verbing Briefly with 一下 (yixia): Append 一下 after a verb to indicate a brief or tentative action, e.g., 你看一下。",
        "Verbs Followed by 给 (gei): Use 给 after a verb to indicate that something is given to a recipient, e.g., 他送给我一束花。",
        "Verbs Preceded by 给 (gei): Place 给 before a verb to indicate that the action is performed for someone, e.g., 现在不要给他打电话。",
        "Verbs with Double Objects: Use a verb followed by both an indirect and a direct object to indicate giving or asking, e.g., 我问了老师一个问题。",
        "Degree Complement with 得 (de): Append 得 after a verb to express the degree or result of an action, e.g., 你做得不错。",
        "Potential Complement for Not Understanding with 不懂 (bu dong): Attach 不懂 after a verb to indicate a lack of understanding, e.g., 我听不懂。",
        "Result Complements with 好/完/错: Follow a verb with 好, 完, or 错 to indicate the outcome of an action, e.g., 我们吃好了。",
        "Result Complements with 到/见 (dao/jian): Use 到 or 见 after a verb to express that an action has successfully reached its target, e.g., 听到了吗？",
        "Result Complement for Finishing with 完 (wan): Append 完 (optionally with 了) after a verb to denote that an action is fully completed, e.g., 我说完了。",
        "Expressing 'Every' with 每 (mei): Prepend 每 before a measure word or noun to indicate every instance, e.g., 每个人, 每天。",
        "Measure Words for Counting: Combine a number with a measure word and a noun to indicate quantity, e.g., 一个人, 一杯水。",
        "Measure Words with 这/那 (zhe/na): Use 这 or 那 before a measure word and noun to specify 'this' or 'that', e.g., 那个人, 这杯水。",
        "Ordinal Numbers with 第 (di): Prepend 第 before a number (and measure word) to express order, e.g., 你是我的第一个朋友。",
        "Affirmative-Negative Questions: Form questions by repeating a verb or adjective in both affirmative and negative forms, e.g., 去不去？好不好？",
        "Asking Why with 怎么 (zenme): Use 怎么 before a verb to inquire about the reason behind an action, e.g., 你怎么没来？",
        "Simple Rhetorical Questions with 不是…吗 (bushi...ma): Use 不是 followed by a rhetorical question to imply an expected answer, e.g., 不是说好了吗？怎么会这样？",
        "Tag Questions with 不…是不是/对不对/好不好: Append a tag question after a statement to seek confirmation, e.g., 你们明天来，好不好？",
        "Tag Questions with 吗 (ma): Add 吗 to the end of a statement to form a yes-no question, e.g., 这样做，对吗？",
        "Cause and Effect with 因为…所以 (yinwei...suoyi): Use 因为 to state the cause and 所以 to present the effect, e.g., 因为饿了，所以吃饭。",
        "Expressing 'About to Happen' with 了 (le): Combine 快 + verb/adjective + 了 to indicate that something is imminent, e.g., 快下雨了。",
        "Expressing 'Everything' with 什么都 (shenme dou): Use 什么 together with 都 or 也 to denote 'everything', e.g., 爸爸什么都知道。",
        "Expressing 'Stop Doing' with 别…了 (bie...le): Prepend 别 and append 了 after a verb to instruct someone to stop an action, e.g., 别哭了，烦死了。",
        "Purpose and Emphasis with 是…的 (shi... de): Use the 是…的 structure to indicate purpose or to emphasize details, e.g., 我是来上海旅游的。",
        "Overview of 是…的 (shi... de): Employ 是…的 to inquire about details or to stress background information, e.g., 你是哪个学校的？",
        "Expressing 'Every Time' with 每次…都 (meici...dou): Use 每次 followed by an event and 都 with another event to denote repetition, e.g., 为什么每次我来他都不在？",
        "Comparative with 比 (bi): Use 比 between two nouns with an adjective and add 多了 to indicate a greater degree, e.g., 拼音比汉字容易多了。",
        "Concessive with 虽然…但是/可是 (suiran...danshi/kesh): Use 虽然 to present a concession and 但是 or 可是 to contrast it, e.g., 虽然渴了，但是不想喝啤酒。"

    ],
    "HSK3": [
        "Adjectives with 极了 (ji le): Append 极了 after an adjective to express an extreme degree, e.g., 这个主意好极了。",
        "Reduplication of Adjectives: Repeat an adjective to soften or emphasize its quality, e.g., 你应该慢慢地走。",
        "Turning Adjectives into Adverbs with 地 (de): Insert 地 after an adjective to modify a verb, e.g., 你要认真地学习。",
        "Expressing 'again' in the past with 又 (you): Prepend 又 before a verb and append 了 to indicate a repeated past action, e.g., 你又迟到了。",
        "Expressing 'all along' with 一直 (yizhi): Place 一直 before the predicate to denote continuous action, e.g., 我一直在现在的公司工作。",
        "Expressing 'always' with 总是 (zongshi): Use 总是 before a verb to indicate habitual action, e.g., 他总是迟到。",
        "Expressing Duration of Inaction with 没…了: Combine a duration with 没 and 了 to denote inaction, e.g., 他已经一个星期没洗澡了。",
        "Expressing 'finally' with 终于 (zhongyu): Insert 终于 before the predicate and 了 at the end to signal a final outcome, e.g., 你终于到了。",
        "Expressing Lateness with 才 (cai): Use 才 after a time marker to show that something happens later than expected, e.g., 他二十五岁才上大学。",
        "Expressing 'nearly' with 几乎 (jihu): Prepend 几乎 before a verb to indicate that something is almost complete, e.g., 他的头发几乎全白了。",
        "Expressing 'only' with 只 (zhi): Use 只 before a verb to indicate limitation, e.g., 我只有一个妹妹。",
        "Sequencing with 先…再… (xian...zai): Use 先 followed by 再 to indicate the order of actions, e.g., 先洗手，再吃饭。",
        "Simultaneous Tasks with 一边…一边… (yibian): Use 一边 before each verb to show simultaneous actions, e.g., 不要一边说话，一边吃东西。",
        "Using 'always' as a Complaint with 老是 (laoshi): Insert 老是 before a verb to express irritation at frequent repetition, e.g., 你怎么老是加班？",
        "Using 才 for Small Numbers (cai): Place 才 before a numeral to emphasize a small quantity, e.g., 这个班才两个学生。",
        "Adjectives with 那么/这么 (name/zheme): Use 那么 or 这么 before an adjective to indicate degree, e.g., 你怎么那么忙？",
        "Basic Comparisons with 一样 (yiyang): Use 跟/和 … 一样 to compare similarity, e.g., 你跟他一样高。",
        "Expressing 'both A and B' with 又…又… (you): Use 又 before each adjective to list dual qualities, e.g., 他又高又帅。",
        "Expressing 'rather' with 比较 (bijiao): Prepend 比较 before an adjective to indicate a moderate degree, e.g., 这个问题比较简单。",
        "Intensifying with 多 (duo): Use 多 before an adjective to intensify praise, e.g., 多好！外面多舒服！",
        "Modifying Nouns with 的 (de): Attach 的 after an adjective to modify a noun, e.g., 好喝的啤酒, 可爱的宝宝。",
        "Expressing 'or' with 或者 (huozhe): Use 或者 to present alternatives, e.g., 我想去青岛或者南京。",
        "Expressing 'then…' with 那么 (name): Use 那么 to suggest a consequence, e.g., 他不听，那么我应该怎么办？",
        "Expressing 'with' using 跟 (gen): Use 跟 before a noun to indicate accompaniment, e.g., 你要跟我一起去吗？",
        "Offering Choices with 还是 (haishi): Use 还是 between alternatives in a question, e.g., 你要喝茶还是咖啡？",
        "Before a Specific Time with 以前 (yiqian): Append 以前 after a time expression to denote 'before', e.g., 十点以前，我在家。",
        "Expressing 'before' in general with 以前 (yiqian): Use 以前 to indicate the past, e.g., 以前，我不会说中文。",
        "Expressing 'just now' with 刚才 (gangcai): Use 刚才 before a verb to refer to the immediate past, e.g., 你刚才说什么了？",
        "Expressing 'when' with 时 (shi): Attach 时 after a time indicator to set the scene, e.g., 考试时不要说话。",
        "In the Future in General with 以后 (yihou): Use 以后 at the beginning of a sentence to refer to future time, e.g., 以后，你不要问我。",
        "Sequencing Past Events with 后来 (houlai): Use 后来 to indicate that an event followed another, e.g., 开始他不同意，但后来同意了。",
        "Approximating with Sequential Numbers: Combine numbers to indicate an approximate range, e.g., 三四个人, 一两天。",
        "Big Numbers in Chinese with 万/亿 (wan/yi): Append 万 or 亿 after a number to denote large quantities, e.g., 五万。",
        "Advanced Time Structure with 点/钟 and 分 (dian/feng): Combine numbers with 点 and 分 for precise time, e.g., 现在十一点十八分。",
        "Basic Time Structure with 点 (dian): Use 点 after a numeral to indicate the hour, e.g., 现在十一点。",
        "Aspect Particle 着 (zhe): Append 着 after a verb to indicate an ongoing state, e.g., 我读，你听着。",
        "Change of State with 了 (le): Attach 了 after a subject or verb to indicate change, e.g., 我25岁了。",
        "Question Particle with 呢 (ne): Append 呢 at the end of a sentence to invite a response, e.g., 我很好，你呢？",
        "Structural Particles 的/得/地 (de): Use 的 for noun modification, 得 for verb complements, and 地 for adverbial modification, e.g., 红色的车, 跑得很快, 慢慢地走。",
        "Expressing 'about' with 关于 (guanyu): Use 关于 before an object to introduce a topic, e.g., 关于中国历史，我知道的不多。",
        "Expressing 'all the way until' with 直到 (zhidao): Use 直到 before a time/event and 才 after the predicate, e.g., 直到十二点半，我才做完作业。",
        "Expressing 'towards' with 向 (xiang): Prepend 向 before a direction or person with a verb, e.g., 你必须向他道歉！",
        "Appearance with 看起来 (kanqilai): Use 看起来 before an adjective to describe appearance, e.g., 这家餐厅看起来不错。",
        "Basic Comparisons with 没有 (meiyou): Use 没有 between two nouns and an adjective to compare, e.g., 你没有我胖。",
        "Causative Verbs with 让/叫/请/使 (rang/jiao/qing/shi): Use one of these before a person to indicate causing an action, e.g., 你为什么不让我去？",
        "Expressing 'through' with 经过 (jingguo): Use 经过 before an event or time to indicate the process, e.g., 经过自己的努力，她考上了北京大学。",
        "Expressing 'should' with 应该/该 (yinggai/gai): Use 应该 or 该 before a verb to denote obligation, e.g., 你应该工作。",
        "Expressing 'difficult' with 难 (nan): Prepend 难 before a verb to denote that it is hard to do, e.g., 难做, 难买。",
        "Expressing Duration with 了 (le): Attach 了 plus a duration after a verb to indicate how long an action lasted, e.g., 他在北京住了两年。",
        "Expressing Ongoing Duration with Double 了 (le): Use 了 after a verb, duration, and again 了 to emphasize continuity, e.g., 他在北京住了两年了。",
        "Expressing Inability with 没办法 (mei banfa): Prepend 没办法 before a verb to indicate inability, e.g., 我没办法帮你。",
        "Reduplication of Verbs: Repeat a verb to indicate a brief or tentative action, e.g., 你看看。",
        "Special Verbs with 很 (hen): Prepend 很 before a verb to emphasize strong feeling, e.g., 我很喜欢他。",
        "Direction Complement with 来/去 (lai/qu): Append 来 or 去 after a verb to indicate movement direction, e.g., 我们走过去吧。",
        "Potential Complement with 得/不 (de): Use 得 or 不 after a verb plus a complement to indicate possibility, e.g., 做得完/做不完。",
        "Result Complements with 好/完/错: Append 好, 完, or 错 after a verb to indicate the result, e.g., 我们吃好了。",
        "Result Complement '-下去' (xiaqu): Attach 下去 after a verb to express inability to continue, e.g., 这个故事太无聊了，我听不下去了。",
        "Conditional 'as long as' with 只要…就… (zhiyao): Use 只要 before a condition and 就 after to indicate a result, e.g., 只要你过来，我们就很开心。",
        "Conditional 'only after' with 才 (cai): Use 才 after an action to stress that a condition was met only after repetition, e.g., 那本书我看了两遍才看懂。",
        "Conditional 'only if' with 只有…才… (zhiyou): Use 只有 before a condition and 才 after the predicate to express necessity, e.g., 只有你帮忙，我才能完成任务。",
        "Using 'some' in Noun Phrases with 有的 (youde): Prepend 有的 before a noun to indicate some people or things, e.g., 派对的时候，有的人在喝酒，有的人在跳舞，还有的人在聊天。",
        "Expressing 'half' with 半 (ban): Insert 半 after a measure word to indicate a half quantity, e.g., 三个半小时。",
        "Expressing 'not even one' with 也/都不/没: Combine a measure word with 也/都不/没 before a verb to indicate total absence, e.g., 一句中文都不会说。",
        "Expressing 'the more... the more...' with 越…越… (yue): Use 越 before a verb and then 越 plus an adjective to denote increasing degree, e.g., 她越想越生气。",
        "Using '把' Sentences (ba): Insert 把 between the subject and object to indicate handling, e.g., 我把书看完了。",
        "Using '被' Sentences (bei): Prepend 被 before the doer to form a passive sentence, e.g., 我被他骗了。",
        "Alternative Existential Sentences: Combine a place, verb, 着, and a noun phrase to describe a state, e.g., 桌子上放着一本书。",
        "Expressing 'as one likes' with 就 (jiu): Use 想 + 问句词 + 就 + 问句词 to indicate freedom of choice, e.g., 想去哪儿就去哪儿。",
        "Expressing 'every' with Question Words: Insert 都 after a question word to indicate inclusivity, e.g., 谁都可以进。",
        "Expressing 'more and more' with 越来越 (yuelaiyue): Prepend 越来越 before an adjective and add 了 to denote gradual change, e.g., 天气越来越冷了。",
        "Expressing Purpose with 为了 (weile): Prepend 为了 before a purpose and follow with a verb, e.g., 为了钱，他什么都愿意做。",
        "Expressing 'some' with Question Words: Use 哪儿/谁/什么/什么时候 to indicate uncertainty, e.g., 这个人我在哪儿见过。",
        "Expressing Comparable Degree with 有…吗 (you): Use 有 between two nouns with an adjective and add 吗 to compare, e.g., 他有我帅吗？",
        "Expressing 'compared with' using 跟 (gen): Use 跟 + noun + 比 to make a comparison, e.g., 跟上海比，北京的冬天比较干。",
        "Expressing 'even more' with 更/还 (geng/hai): Use 更 or 还 after 比 to intensify a comparison, e.g., 他比姚明还高。",
        "Expressing 'much more' with 多了 (duo le): Append 多了 after an adjective in a comparison, e.g., 拼音比汉字容易多了。",
        "Complex Sentence 'except/in addition' with 除了…以外 (chule...yiwai): Use 除了 before a subject and then 都/也/还 after to indicate inclusion or exception, e.g., 除了他，我们都去过。",
        "Complex Sentence 'if... then...' with 如果…就… (ruguo...jiu): Use 如果 for a condition and 就 for the result, e.g., 如果有困难，就给我打电话。",
        "Complex Sentence 'if' with 如果…的话 (ruguo... dehua): Use 如果 (的话) then (就) to set a conditional, e.g., 如果明天下雨的话，我们就不去了。",
        "Complex Sentence 'not only... but also' with 不但…而且… (budan...erqie): Use 不但 before the first clause and 而且 before the second to join qualities, e.g., 他不但聪明，而且勤劳。",
        "Comparing 才 and 就 (cai vs jiu): Use 才 for delayed or limited action and 就 for immediacy, e.g., 我花了两天才修好，你一下子就弄坏了。",
        "Comparing 刚 and 刚才 (gang vs gangcai): Use 刚 for a recent action and 刚才 for the immediate past, e.g., 你刚才去哪儿了？我刚回来。",
        "Comparing 有点 and 一点 (youdian vs yidian): Use 有点 to indicate 'somewhat' and 一点 for a small degree, e.g., 这衣服有点贵，便宜一点吧。",
        "Comparing 再 and 又 (zai vs you): Use 再 for future repetition and 又 for repeated past actions, e.g., 我不能再喝了，你走后我又喝了两瓶。",
        "Comparing 还是 and 或者 (haishi vs huozhe): Use 还是 in questions to offer choices and 或者 to suggest alternatives, e.g., 我们明天见还是后天见？明天或者后天都可以。",
        "Comparing 以后, 然后, and 后来 (yihou vs ranhou vs houlai): Use 以后 for future reference, 然后 for sequence, and 后来 for subsequent events, e.g., 我以后想开公司。/ 后来他去了美国，然后他的父母也搬过去了。"

    ],
    "HSK4": [
        "Indicating the Whole with 全 (quan): Use 全 before a noun to denote entirety, e.g., 我们全家都去旅游了。",
        "Negative Adjectives with -死了 (si le): Append 死了 after an adjective to intensify its negative quality, e.g., 我今天累死了。",
        "Approximations with 差不多 (chabuduo): Use 差不多 after the subject to indicate approximation, e.g., 我们的中文水平差不多。",
        "Assessing Situations with 看来 (kanlai): Place 看来 (or 在…看来) before a judgment to assess a situation, e.g., 看来他不来了，都这么晚了。",
        "Coincidence with 正好 (zhenghao): Insert 正好 before a verb phrase to denote coincidental timing, e.g., 他正好问了我想问的问题。",
        "Declaring the Only Option with 只好 (zhihao): Use 只好 before a verb phrase to express having no alternative, e.g., 上个周末下雨了，我们只好待在家。",
        "Emphasizing Negation with 又不/没 (you): Prepend 又 followed by 不 or 没 before a verb to stress negation, e.g., 又没下雨，带伞干吗？",
        "Emphatic Adverb 可 (ke): Use 可 before an adjective (optionally with 了) to emphasize its degree, e.g., 这件事情对他造成的影响可大了。",
        "Expressing 'All Along' with 原来 (yuanlai): Use 原来 before the predicate to reveal a previously unknown fact, e.g., 原来昨天那个人是你啊。",
        "Expressing 'Almost' with 差点 (chadian): Insert 差点 (儿) before the predicate to indicate near occurrence, e.g., 我今天差点儿迟到了。",
        "Expressing 'Always' with 从来 (conglai): Combine 从来 with 都 (or 是) before the predicate to emphasize a constant state, e.g., 我从来都是一个人，已经习惯了。",
        "Expressing 'As a Result' with 结果 (jieguo): Place 结果 after a reason to introduce its outcome, e.g., 他没好好复习，结果没通过考试。",
        "Expressing Concern with 恐怕 (kongpa): Prepend 恐怕 to a sentence to express worry, e.g., 恐怕今天做不完。",
        "Expressing 'Enough' with 够 (gou): Use 够 before the predicate (optionally with 了) to indicate sufficiency, e.g., 我们买了很多菜，够吃了。",
        "Expressing 'Even' with 甚至 (shenzhi): Insert 甚至 before an extreme case to stress its inclusiveness, e.g., 他们贡献出所有的精力，甚至最宝贵的生命。",
        "Expressing 'Had Better' with 还是 (haishi): Use 还是 before a verb to suggest the preferable option, e.g., 我们还是先吃饭吧。",
        "Expressing 'Had Better' with 最好 (zuihao): Prepend 最好 before the predicate to recommend an optimal course, e.g., 你最好先休息一下。",
        "Expressing 'Have To' with 不得不 (budebu): Use 不得不 before a verb to indicate necessity despite reluctance, e.g., 老板很讨厌应酬，但是她不得不去。",
        "Expressing 'In the End' with 到底 (daodi): Use 到底 to stress the final outcome, e.g., 事情到底是办成了。",
        "Expressing 'In the End' with 究竟 (jiujing): Place 究竟 before a predicate to ask for clarification of a result, e.g., 你究竟喜不喜欢我？",
        "Expressing 'Just' with 刚 (gang): Use 刚 before a verb to denote a very recent action, e.g., 他刚走。",
        "Expressing 'One by One' with 一…一… (yi): Repeat 一 with a measure word to indicate sequential progression, e.g., 宝宝一天一天在长大。",
        "Expressing 'Originally' with 本来 (benlai): Use 本来 to indicate an original state or expectation, e.g., 搬家本来就很麻烦。",
        "Expressing 'Small Quantity' with 就 (jiu): Use 就 before the subject or predicate to denote exclusivity, e.g., 这件事就我一个人知道。",
        "Expressing the Unexpected with 竟然 (jingran): Prepend 竟然 before a verb phrase to express surprise, e.g., 我们要出发的时候，他竟然说不去了。",
        "Expressing 'To Make Certain' with 千万 (qianwan): Use 千万 before a verb phrase to urge extreme caution, e.g., 千万别泄露出去。",
        "Rhetorical Questions with 难道 (nandao): Start a question with 难道 to express rhetorical doubt, e.g., 这都是你引起的，难道你就不内疚？",
        "Sequencing with 先…再… (xian...zai): Use 先 followed by 再 to indicate the order of actions, e.g., 先洗手，再吃饭。",
        "Using '也都' (ye/dou): Combine 也都 before a verb or adjective to emphasize that all elements are included, e.g., 他们也都是法国人。",
        "Expressing 'Quite' with 挺 (ting): Prepend 挺 before an adjective and add 的 to intensify it, e.g., 你男朋友挺帅的。",
        "Ending a Non-Exhaustive List with 什么的 (shenme de): Use 什么的 after listing examples to imply more items exist, e.g., 明天去野餐，我们要不要买一些水果，零食什么的。",
        "Non-Exhaustive Lists with 等等 (dengdeng): Append 等 or 等等 after items to indicate continuation, e.g., 长城、故宫等等都是北京有名的景点。",
        "A Softer 'But' with 不过 (buguo): Use 不过 to introduce a mild contrast, e.g., 他的汉语口语不错，不过不认识汉字。",
        "Expressing 'And Then' with 于是 (yushi): Use 于是 to denote a subsequent result, e.g., 他实在太懒了，于是老板把他辞了。",
        "Expressing 'In Addition' with 还有 (haiyou): Insert 还有 to add further information, e.g., 你需要吃药，还有，要多休息。",
        "Expressing 'In Addition' with 另外 (lingwai): Prepend 另外 before extra details, e.g., 希望你不要再迟到了。另外，你应该穿得正式一点。",
        "Expressing 'In Addition' with 再说 (zaishuo): Use 再说 to further justify or add information, e.g., 这么晚，别走了。再说，外面还在下雨。",
        "Using 'But' with 可是/但是 (kese/danshi): Use 可是 or 但是 to introduce a clear contrast, e.g., 我喜欢他，可是他不喜欢我。",
        "Contrasting with 而 (er): Insert 而 between sentences to contrast ideas, e.g., 以后后悔的人不是我，而是你自己。",
        "Connecting Verb Phrases with 来 (lai): Use 通过或用 + 方法 + 来 before a verb phrase to indicate means, e.g., 用这种方法来赚钱，真丢人。",
        "Expressing 'Within' with 其中 (qizhong): Use 其中 to specify a subset within a group, e.g., 有五个人报名了，其中两个是女生。",
        "Expressing Fractions with 分之 (fenzhi): Combine the denominator, 分之, and numerator to denote fractions, e.g., 在我们班，外国学生占三分之一。",
        "Advanced Yes-No Questions with 吗 (ma): Use 吗 at the end of a confirmation-question to elicit a yes/no response, e.g., 你要什么吗？",
        "Reviewing Options with 吧 (ba): Append 吧 after choices to invite agreement, e.g., 不说吧，他还会做错；说吧，他肯定不高兴。",
        "Using 的 as a Modal Particle (de): Attach 的 after a statement to add an assuring tone, e.g., 我不会骗你的。",
        "Expressing 'Along With' with 随着 (suizhe): Use 随着 followed by A的 and a verb to indicate concurrent change, e.g., 随着经济的发展，人们的生活越来越好。",
        "Idiomatic Phrases with 在…上 (zai): Use 在 followed by a topic and 上 to set context, e.g., 在美国历史上，最重要的总统是谁？",
        "Expressing 'Taking A as B' with 以…为… (yi...wei...): Use 以 followed by A and 为 followed by B to indicate basis, e.g., 我们公司是以亚洲市场为主，以欧美市场为辅。",
        "Emphasizing Negation with 并不 (bing): Prepend 并不 before a verb or adjective to strongly negate, e.g., 当金融分析人员并不是我的梦想。",
        "Using 把 for Handling (ba): Insert 把 between the subject and object to indicate handling, e.g., 我把书看完了。",
        "Using 被 for Passive Constructions (bei): Prepend 被 before the doer in a passive sentence, e.g., 我被他骗了。",
        "Alternative Existential Sentences: Combine a place, verb, 着, and a noun phrase to describe a state, e.g., 桌子上放着一本书。",
        "Expressing 'As One Likes' with 就 (jiu): Use 想 + 问句词 + 就 + 问句词 to denote freedom of choice, e.g., 想去哪儿就去哪儿。",
        "Expressing 'Every' with Question Words: Insert 都 after a question word to indicate inclusivity, e.g., 谁都可以进。",
        "Expressing 'Multiples' with 的倍 (bei): Use 是...的...倍 to denote multiples, e.g., 他现在的工资是两年前的三倍。",
        "Expressing 'Not At All' with 一点也不 (yidianr ye bu): Prepend 一点也不 before an adjective to indicate total absence, e.g., 你一点也不胖。",
        "Expressing Not Knowing How to Do Something with 好 (hao): Use 不知道 followed by a verb phrase and 好 to express uncertainty, e.g., 我真的不知道怎么办才好。",
        "Phrases Using 来说 (laishuo): Use 对…来说 or 一般来说 to express a perspective, e.g., 一般来说，私立学校都比较贵。",
        "Conceding with 是 (shi): Use Adj. + 是 + Adj., but… to concede a point, e.g., 这个东西好是好，就是太贵了。",
        "Events in Quick Succession with 一…就… (yi...jiu): Use 一 before an event and 就 before the next to show immediate sequence, e.g., 他一到家，就去洗澡了。",
        "Expressing Various Aspects with 一方面…一方面… (yi fangmian): Use 一方面 followed by 一方面 to contrast different aspects, e.g., 一方面他很喜欢这份工作，一方面他又觉得工资太低。",
        "Not Only...But Also... with 不但…而且… (budan...erqie): Use 不但 (or 不仅) before the first clause and 而且 (or 还/也) before the second to join qualities, e.g., 他不仅喜欢吃中国菜，而且也会做几个中国菜！",
        "Comparing 本来 vs 原来 (benlai vs yuanlai): Distinguish between 本来 (originally, as planned) and 原来 (as it turns out), e.g., 他原来的公司本来要派他去上海，但是因为家里有事，去不了了。",
        "Comparing 常常 vs 往往 (changchang vs wangwang): Use 常常 for frequent actions and 往往 for typical outcomes, e.g., 我不常运动，我往往呆在家里。",
        "Comparing 刚 vs 刚才 (gang vs gangcai): Use 刚 for recent actions and 刚才 for the immediate past, e.g., 你刚才去哪儿了？我刚回来。",
        "Comparing 关于 vs 对于 (guanyu vs duiyu): Use 关于 to introduce a topic and 对于 to indicate relation, e.g., 对于那个人，关于我们的学习方法。",
        "Comparing 离 vs 从 (li vs cong): Use 离 to indicate distance and 从 to denote a starting point, e.g., 从明天开始，我不抽烟了。",
        "Comparing 反而 vs 相反 (fan'er vs xiangfan): Use 反而 to indicate an unexpected opposite result and 相反 to simply contrast, e.g., 吃水果不但对他没好处，反而有坏处。老板的想法跟我的相反。",
        "Comparing 肯定, 确定, and 一定 (kending vs queding vs yiding): Use 肯定 for assurance, 确定 for certainty, and 一定 for emphasis, e.g., 老板肯定了我们团队的工作。你确定他是我们要找的人？一定要小心。",
        "Comparing 适合 vs 合适 (shihe vs heshi): Use 适合 to indicate suitability and 合适 to denote proper fit, e.g., 这个颜色不适合他，黑色才是最合适的。",
        "Comparing 以后 vs 的时候 (yihou vs de shihou): Use 的时候 to refer to a specific time and 以后 for later periods, e.g., 打篮球的时候会出很多汗，所以打完篮球以后我要洗澡。"
    ],
    "HSK5": [
        "Adjectives with 为首 (weishou): Append 为首 after a subject to indicate leadership, e.g., 他是以你为首的团队的成员。",
        "Expressing 'As a Matter of Fact' with 事实上 (shishi shang): Begin a sentence with 事实上 to present a fact that contradicts expectation, e.g., 事实上，我根本不在乎。",
        "Expressing 'By Means Of' with 借助 (jiezhu): Insert 借助 before a tool to denote using something to achieve a task, e.g., 借助电脑能帮你提高工作效率。",
        "Expressing 'In My Opinion' with 依我看 (yi wo kan): Prepend 依我看/依他看 before a statement to indicate a personal opinion, e.g., 依我看，你最好去检查一下。",
        "Expressing 'Nothing Serious' with 没什么大不了 (mei shenme da bu liao): Use 没什么大不了的 after a statement to downplay significance, e.g., 我有点儿感冒，没什么大不了的。",
        "Expressing 'On the Whole' with 总体上 (zongti shang): Begin a statement with 总体上 to indicate a general summary, e.g., 总体上看来，这些学生不错。",
        "Expressing 'Simply' with 简直 (jianzhi): Use 简直 before a predicate to stress that something is almost unbelievable, e.g., 她简直要哭出来了。",
        "Expressing Wasted Efforts with 白 (bai): Prepend 白 before a verb to imply futility, e.g., 白花了一百块钱，这件衣服不能穿。",
        "Expressing 'While You're at It' with 顺便 (shunbian): Use 顺便 after an initial verb phrase to add an extra, convenient action, e.g., 你出去的时候顺便帮我买杯咖啡。",
        "Repeated Past Actions with 又 (you): Combine 了 and 又 between repetitions to indicate repeated attempts, e.g., 他找了又找，还是没找到他的钱包。",
        "The Opposite of '差不多' is '差很多' (cha hen duo): Attach 差很多 after the subject to denote a significant difference, e.g., 中国文化和西方文化差很多。"
    ]
}; // Semicolon added

// Helper function to get the display label (text before the colon)
const getGrammarLabel = (fullItem) => {
    // Extract just the description up to the colon
    const match = fullItem.match(/^(.*?):/);
    if (match && match[1]) {
        return match[1];
    }
    // Fallback to the first few characters if pattern not found
    return fullItem.substring(0, 30) + '...';
};

// Chinese vocabulary levels (HSK)
const chineseVocabLevels = ["HSK1 (150 words)", "HSK2 (150 words)", "HSK3 (300 words)", "HSK4 (600 words)", "HSK5 (1300 words)"]; // Removed HSK6

//
// Sub-Components for the different modes
//

// Vocabulary Mode: Render vocabulary level selector and topic selection.
function ChineseVocabularyMenu({ // Renamed component
    selectedVocabularyLevels,
    setSelectedVocabularyLevels,
    selectedTopics,
    setSelectedTopics,
    customTopicEnabled,
    setCustomTopicEnabled,
    customTopic,
    setCustomTopic,
    openDropdown,
    setOpenDropdown,
}) {
    return (
        <>
            <CollapsibleSection
                label="Select Vocabulary Level"
                isOpen={openDropdown === 'Chinese_SelectVocabularyLevel'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Chinese_SelectVocabularyLevel' ? null : 'Chinese_SelectVocabularyLevel')
                }
            >
                <div className="vocab-level-checkbox-group">
                    {chineseVocabLevels.map((level) => (
                        <label key={level} className="vocab-level-checkbox-label option-label">
                            <input
                                type="checkbox"
                                name="vocabularyLevel"
                                value={level}
                                checked={selectedVocabularyLevels.includes(level)}
                                onChange={(e) => {
                                    let newSelected = [...selectedVocabularyLevels];
                                    if (e.target.checked) {
                                        newSelected.push(level);
                                    } else {
                                        newSelected = newSelected.filter((v) => v !== level);
                                    }
                                    setSelectedVocabularyLevels(newSelected);
                                }}
                            />
                            {level}
                        </label>
                    ))}
                </div>
            </CollapsibleSection>
            <CollapsibleSection
                label="Select Topics"
                isOpen={openDropdown === 'Chinese_SelectTopics'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Chinese_SelectTopics' ? null : 'Chinese_SelectTopics')
                }
            >
                <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                    {topicsList.map((topic, index) => (
                        <div key={index}>
                            <label className="home-menu-label option-label">
                                <input
                                    type="checkbox"
                                    checked={selectedTopics.includes(topic)}
                                    onChange={() => {
                                        if (selectedTopics.includes(topic)) {
                                            setSelectedTopics(selectedTopics.filter((t) => t !== topic));
                                        } else {
                                            setSelectedTopics([...selectedTopics, topic]);
                                        }
                                    }}
                                />
                                {topic}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="custom-topic-container" style={{ marginTop: '10px' }}>
                    <label className="home-menu-label option-label">
                        <input
                            type="checkbox"
                            checked={customTopicEnabled}
                            onChange={(e) => {
                                setCustomTopicEnabled(e.target.checked);
                                if (!e.target.checked) {
                                    setCustomTopic("");
                                }
                            }}
                        />
                        Custom
                    </label>
                    {customTopicEnabled && (
                        <div style={{ marginTop: '5px' }}>
                            <input
                                type="text"
                                value={customTopic}
                                onChange={(e) => setCustomTopic(e.target.value)}
                                placeholder="Enter your custom topic"
                                style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', color: '#333' }}
                            />
                            <div style={{ fontSize: '0.8em', fontStyle: 'italic', marginTop: '3px', color: '#333' }}>
                                Or select from the topics above.
                            </div>
                        </div>
                    )}
                </div>
            </CollapsibleSection>
        </>
    );
}

// Grammar Mode: Render vocabulary level selector and grammar items per level.
function ChineseGrammarMenu({ // Renamed component
    selectedVocabularyLevels,
    setSelectedVocabularyLevels,
    selectedGrammarItems,
    setSelectedGrammarItems,
    selectedTopics,
    setSelectedTopics,
    customTopicEnabled,
    setCustomTopicEnabled,
    customTopic,
    setCustomTopic,
    openDropdown,
    setOpenDropdown,
}) {
    return (
        <>
            {/* Grammar Level Selection */}
            <CollapsibleSection
                label="Select Grammar Level"
                isOpen={openDropdown === 'Chinese_SelectGrammarLevel'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Chinese_SelectGrammarLevel' ? null : 'Chinese_SelectGrammarLevel')
                }
            >
                <div className="vocab-level-checkbox-group">
                    {chineseVocabLevels.map((level) => (
                        <label key={level} className="vocab-level-checkbox-label option-label">
                            <input
                                type="checkbox"
                                name="vocabularyLevel"
                                value={level}
                                checked={selectedVocabularyLevels.includes(level)}
                                onChange={(e) => {
                                    let newSelected = [...selectedVocabularyLevels];
                                    if (e.target.checked) {
                                        newSelected.push(level);
                                    } else {
                                        newSelected = newSelected.filter((v) => v !== level);
                                        const newGrammar = { ...selectedGrammarItems };
                                        delete newGrammar[level];
                                        setSelectedGrammarItems(newGrammar);
                                    }
                                    setSelectedVocabularyLevels(newSelected);
                                }}
                            />
                            {level}
                        </label>
                    ))}
                </div>
            </CollapsibleSection>

            {/* Grammar Item Selection */}
            {selectedVocabularyLevels.map((level) => (
                (chineseGrammarItems[level]?.length > 0) && (
                    <CollapsibleSection
                        key={level}
                        label={`${level} Grammar`}
                        isOpen={openDropdown === `Chinese_Grammar_${level}`}
                        onToggle={() =>
                            setOpenDropdown(openDropdown === `Chinese_Grammar_${level}` ? null : `Chinese_Grammar_${level}`)
                        }
                    >
                        <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                            {(chineseGrammarItems[level] || []).map((item, index) => (
                                <div key={index}>
                                    <label className="home-menu-label option-label">
                                        <input
                                            type="checkbox"
                                            value={item}
                                            checked={selectedGrammarItems[level]?.includes(item) || false}
                                            onChange={(e) => {
                                                let currentLevelSelection = selectedGrammarItems[level] || [];
                                                let newLevelSelection;
                                                if (e.target.checked) {
                                                    newLevelSelection = [...currentLevelSelection, item];
                                                } else {
                                                    newLevelSelection = currentLevelSelection.filter((i) => i !== item);
                                                }
                                                setSelectedGrammarItems({ ...selectedGrammarItems, [level]: newLevelSelection });
                                            }}
                                        />
                                        {getGrammarLabel(item)}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </CollapsibleSection>
                )
            ))}

            {/* Topic Selection (same as Vocabulary mode) */}
            <CollapsibleSection
                label="Select Topics"
                isOpen={openDropdown === 'Chinese_SelectTopics'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Chinese_SelectTopics' ? null : 'Chinese_SelectTopics')
                }
            >
                <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>
                    {topicsList.map((topic, index) => (
                        <div key={index}>
                            <label className="home-menu-label option-label">
                                <input
                                    type="checkbox"
                                    checked={selectedTopics.includes(topic)}
                                    onChange={() => {
                                        if (selectedTopics.includes(topic)) {
                                            setSelectedTopics(selectedTopics.filter((t) => t !== topic));
                                        } else {
                                            setSelectedTopics([...selectedTopics, topic]);
                                        }
                                    }}
                                />
                                {topic}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="custom-topic-container" style={{ marginTop: '10px' }}>
                    <label className="home-menu-label option-label">
                        <input
                            type="checkbox"
                            checked={customTopicEnabled}
                            onChange={(e) => {
                                setCustomTopicEnabled(e.target.checked);
                                if (!e.target.checked) {
                                    setCustomTopic("");
                                }
                            }}
                        />
                        Custom
                    </label>
                    {customTopicEnabled && (
                        <div style={{ marginTop: '5px' }}>
                            <input
                                type="text"
                                value={customTopic}
                                onChange={(e) => setCustomTopic(e.target.value)}
                                placeholder="Enter your custom topic"
                                style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', color: '#333' }}
                            />
                            <div style={{ fontSize: '0.8em', fontStyle: 'italic', marginTop: '3px', color: '#333' }}>
                                Or select from the topics above.
                            </div>
                        </div>
                    )}
                </div>
            </CollapsibleSection>
        </>
    );
}

// Main Component: Renders appropriate sub-component based on mode
const ChineseMenu = (props) => { // Renamed component
    const { 
        learningMode, 
        setLearningMode, 
        openDropdown, 
        setOpenDropdown 
    } = props; // Extract necessary props including openDropdown and its setter

    // Handle mode change logic (simple radio buttons)
    const handleModeChange = (event) => {
        // Directly call the setLearningMode passed from Home.js
            setLearningMode(event.target.value);
    };

    return (
        <div className="language-menu-container">
            {/* Mode Selection in Collapsible Section */}
            <CollapsibleSection
                label="Learning Mode"
                isOpen={openDropdown === 'Chinese_LearningMode'}
                onToggle={() =>
                    setOpenDropdown(openDropdown === 'Chinese_LearningMode' ? null : 'Chinese_LearningMode')
                }
            >
                <div className="mode-selection">
                <div>
                        <label className="home-menu-label option-label">
                        <input
                            type="radio"
                            name="learningMode"
                            value="Vocabulary"
                                checked={learningMode === 'Vocabulary'}
                                onChange={handleModeChange}
                        />
                            Vocabulary
                    </label>
                </div>
                <div>
                        <label className="home-menu-label option-label">
                        <input
                            type="radio"
                            name="learningMode"
                            value="Grammar"
                                checked={learningMode === 'Grammar'}
                                onChange={handleModeChange}
                        />
                            Grammar
                    </label>
                    </div>
                </div>
            </CollapsibleSection>

            {/* Render menu based on selected mode */}
            {learningMode === 'Vocabulary' ? (
                <ChineseVocabularyMenu {...props} /> // Render ChineseVocabularyMenu
            ) : (
                <ChineseGrammarMenu {...props} /> // Render ChineseGrammarMenu
            )}
        </div>
    );
};

export default ChineseMenu; // Export ChineseMenu